module.exports = __webpack_public_path__ + "static/abtests-c963af04d7c0b30485b1e371961a731b.png";